<template>
  <div class="floor10-wrapper">
    <div class="content" @click="goUrl('https://wap.myzebravip.com/store/?shopId=35149')"><img src="~images/floor10/floor10-desc.png" alt=""></div>
  </div>
</template>

<script>
  export default {
    methods: {
      goUrl(url){
        window.location.href = url
      }
    },
  }
</script>

<style scoped lang="less">
.floor10-wrapper{
  width: 100%;
  height: 100%;
  background-image: url(~images/floor6/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  .content{
    position: absolute;
    top: 15%;
    left: 50%;
    width: 50%;
    transform: translate(-50%,0);
    img{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/floor/floor_10.vue